 <div class="wrapper">
      <div class="col">
        <label *ngIf="labelName" class="m-0 p-0 text-black" for="validationCustom01">{{labelName}}<span *ngIf="isRequired" class="text-danger">*</span></label>
        <div ngbDropdown  #dropdown="ngbDropdown" class="d-inline-block w-100" (openChange)="clearSearch()">
          <button type="button" class="btn text-truncate w-100 selected" [id]="id" ngbDropdownToggle>
           <span *ngIf="!isDatePipe">{{ selectedDisplayValue || dropdownLabel || 'Select' }}</span>
          <span *ngIf="isDatePipe">{{ selectedDisplayValue ? (selectedDisplayValue | date:'yyyy-MM-dd') : (dropdownLabel || 'Select') }}</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="option-div p-1">
            <div *ngIf="isSearchInput" class="search-option mb-2 d-flex justify-content-center">
              <input placeholder="Search" class="search-input p-0" type="text" [(ngModel)]="searchInput" (ngModelChange)="filterOptions()" (keydown.enter)="onEnter()" >
            </div>
            <ng-container *ngFor="let option of filteredOptions; let i = index">
            <button [disabled]="option.disabled" [ngClass]="{'optionDisable':option.disabled}" class="options p-1" ngbDropdownItem  [id]="option.id" [class.highlighted]="i == highlightedIndex" (click)="option.disabled?null:selectOption(option)">
              <ng-container *ngIf="selectedId==option.id">
                <svg class="me-1 right-svg" xmlns="http://www.w3.org/2000/svg" width="9.006" height="5.573" viewBox="0 0 9.006 5.573">
                  <path id="Path_3416" data-name="Path 3416" d="M6.2,5.875l2.1,3.077L13.8,4.581" transform="translate(-5.501 -3.879)" fill="none" stroke="#383838" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                </svg>
              </ng-container>
              <span *ngIf="!isDatePipe"> {{option.name}}</span>
              <span *ngIf="isDatePipe"> {{option.name |  date:'yyyy-MM-dd'}}</span>
            </button>
            </ng-container>
            <ng-container *ngIf="!filteredOptions.length">
              <div class="font-10 text-black ps-1">No data found</div>
          </ng-container>
        </div>
      </div>
</div>

